import React from "react";
import "../../css/flex.grid.css";
import "../../css/home.page.css";
import "../../css/fonts.css";

import { ContainerNoBg } from "../../components/container.no.bg";
import { Clickable } from "../../components/clickable.container";
import { ImportAll } from "../../utils/utils";
import { useIsMobile } from "../../hooks/is.mobile";
import { useNavigate } from "react-router-dom";
import Posts from "../../components/posts/posts";

const images = ImportAll(
  require.context("../../assets/services", false, /\.(png|jpe?g|svg)$/),
);

export const Home: React.FC<any> = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <ContainerNoBg>
      <div className="homepage-header-container">
        <div className={"homepage-title" + " " + "title-text-font"}>
          FUELING THE FUTURE OF PLAY.
        </div>
      </div>
      <div className="homepage-services-container">
        <div
          className={
            isMobile ? "flex-grid-one-column" : "flex-grid-three-columns"
          }
        >
          <div className="homepage-service-clickable-container">
            <Clickable
              onclick={() => {
                navigate("/game-development");
              }}
              children={
                <div
                  className={
                    "title-text-font" + " " + "homepage-service-font-size"
                  }
                >
                  GAME DEVELOPMENT
                </div>
              }
              style="homepage-service-clickable"
              backgroundUrl={images[0]}
            />
          </div>
          <div className="homepage-service-clickable-container">
            <Clickable
              onclick={() => {
                navigate("/3dassets");
              }}
              children={
                <div
                  className={
                    "title-text-font" + " " + "homepage-service-font-size"
                  }
                >
                  ASSETS/TOOLS
                </div>
              }
              style="homepage-service-clickable"
              backgroundUrl={images[1]}
            />
          </div>
          {/* <div className="homepage-service-clickable-container">
            <Clickable
              onclick={() => {
                navigate("/development-tools");
              }}
              children={
                <div
                  className={
                    "title-text-font" + " " + "homepage-service-font-size"
                  }
                >
                  TOOLS / SYSTEMS
                </div>
              }
              style="homepage-service-clickable"
              backgroundUrl={images[4]}
            />
          </div> */}
          {/* <div className="homepage-service-clickable-container">
            <Clickable
              onclick={() => {
                navigate("/art3D");
              }}
              style="homepage-service-clickable"
              children={
                <div
                  className={
                    "title-text-font" + " " + "homepage-service-font-size"
                  }
                >
                  3D ART
                </div>
              }
              backgroundUrl={images[2]}
            />
          </div> */}
          <div className="homepage-service-clickable-container">
            <Clickable
              onclick={() => {
                navigate("/audio");
              }}
              children={
                <div
                  className={
                    "title-text-font" + " " + "homepage-service-font-size"
                  }
                >
                  AUDIO DESIGN
                </div>
              }
              style="homepage-service-clickable"
              backgroundUrl={images[2]}
            />
          </div>
        </div>
      </div>
      <div className="homepage-gradient-fix-element"></div>
      {/* PRESSKIT */}
      <div
        style={{
          display: "flex",
          paddingTop: isMobile ? "4vw" : "4vw",
          paddingBottom: isMobile ? "4vw" : "4vw",
          justifyContent: "center",
        }}
      >
        <Clickable
          onclick={() => {}}
          children={
            <a
              href="/PressKit.rar"
              download
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                justifySelf: "center",
                fontSize: "6vw",
                textAlign: "center",
                color: "white",
                fontFamily: "Orbitron",
                fontWeight: "bold",
              }}
            >
              DOWNLOAD PRESS-KIT
            </a>
          }
          backgroundUrl=""
          style="icon-link-presskit"
        />
      </div>
      <Posts maxPosts={3} />

      {/* PRESSKIT */}
      <div
        style={{
          display: "flex",
          paddingTop: isMobile ? "4vw" : "4vw",
          paddingBottom: isMobile ? "4vw" : "4vw",
          justifyContent: "center",
        }}
      >
        <Clickable
          onclick={() => {
            navigate("/news");
          }}
          children={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                justifySelf: "center",
                fontSize: isMobile ? "4vw" : "2vw",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              See all news...
            </div>
          }
          backgroundUrl=""
          style="icon-link-presskit"
        />
      </div>
    </ContainerNoBg>
  );
};
